import { render, staticRenderFns } from "./PlanOnboardSection.vue?vue&type=template&id=16001b1b&scoped=true"
import script from "./PlanOnboardSection.vue?vue&type=script&lang=js"
export * from "./PlanOnboardSection.vue?vue&type=script&lang=js"
import style0 from "./PlanOnboardSection.vue?vue&type=style&index=0&id=16001b1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16001b1b",
  null
  
)

export default component.exports